import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getSurveyAction } from '../../redux/toolkit/survey/getSurvey'
import { surveyStatusAction } from '../../redux/toolkit/survey/surveyStatus'
import PropTypes from 'prop-types';

export default function LiveSurvey({ survey_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const surveyState = useSelector(state => state.surveyStatus)
    const { status: surveyStatus, message: surveyMsg } = surveyState

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const handleLive = async () => {
        const liveSurvyData = await dispatch(surveyStatusAction({ survey_id: survey_id, status: 'live' }))
        if (liveSurvyData?.payload?.status == 200) {
            await dispatch(getSurveyAction({ is_deleted: false }))
            setSnack(true)
        }
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Survey Activation request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to Activate the selected survey ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLive} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={surveyStatus} message={surveyMsg} />
        </>

    )
}

LiveSurvey.propTypes = {
    survey_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};